module.exports = __webpack_public_path__ + "assets/images/7181ca315dfc388c0a9fa8fddfbfd79d.png";